import type { TMenuItem } from 'components/navigation/NavMenuItem/index.js';
import { NavMenuItem } from 'components/navigation/NavMenuItem/index.js';
import type { FC } from 'react';
import { memo } from 'react';

import { List } from './MainNavigation.styles.js';

interface MainNavigationProps {
  menuButtons: TMenuItem[];
}

export const MainNavigation: FC<MainNavigationProps> = memo(
  ({ menuButtons }) => {
    return (
      <List>
        {menuButtons.map(item => (
          <NavMenuItem key={item.label} {...item} />
        ))}
      </List>
    );
  },
);

MainNavigation.displayName = 'MainNavigation';
